import {
  GUI_EMAIL,
  GUI_EMAIL_SUCCESS,
  GUI_EMAIL_FAILURE,
  SHOW_GUI_EMAIL,
} from "actions/GuiEmail/actionTypes";

const initialState = {
  guiEmailLoading: false,
  showModalEmail: false,
};

const guiEmail = (state, action) => ({
  ...state,
  guiEmailLoading: true,
});

const guiEmailSuccess = (state, action) => {
  return {
    ...state,
    guiEmailLoading: false,
    showModalEmail: false,
  };
};

const guiEmailFailed = (state, action) => ({
  ...state,
  guiEmailLoading: false,
});
const showModalGuiEmail = (state, action) => {
  return {
    ...state,
    showModalEmail: !state.showModalEmail,
  };
};

const guiEmailReducer = (state = initialState, action) => {
  switch (action.type) {
    case GUI_EMAIL:
      return guiEmail(state, action);
    case GUI_EMAIL_SUCCESS:
      return guiEmailSuccess(state, action);
    case GUI_EMAIL_FAILURE:
      return guiEmailFailed(state, action);
    case SHOW_GUI_EMAIL:
      return showModalGuiEmail(state, action);
    default:
      return state;
  }
};

export default guiEmailReducer;
